import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Audio } from "./Audio";
import { get, remove } from '../../services/storage.service';
import axios from "axios";
import { logOutOutline, chevronBackOutline } from 'ionicons/icons';
import FooterComponent from "../FooterComponent";
import LoginCheck from "../LoginCheck";
import './PostsContainer.css';

import {
  IonContent,
  IonHeader,
  IonPage,
  IonToolbar,
  IonButton,
  IonIcon,
  IonText,
  IonLoading
} from "@ionic/react";

export default function AudioContainer() {
  let { catid } = useParams<any>();
  const [posts, setPosts] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [totPages, setTotPages] = useState<number>(1);
  const [showLoading, setShowLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
   
    async function loadPosts() {
      
      /***************FRANKENSTEIN'S MONSTER*************************/
      setShowLoading(true);
      get("cred")
      .then(function (finalResult) { //get the user data to authenticate the user
          const userD = JSON.parse(finalResult);
          console.log(userD.email);
          //axios.get('https://explorermind.wpengine.com/wp-json/wp/v2/audio/?&paged=' + page, { //test site
          axios.get('https://explorermindsetapp.com/wp-json/wp/v2/audio/?&paged=' + page, { //live site
              headers: {
                  'Authentication': 'Bearer ' + userD.authtoken
              },
              timeout: 8000
          })
              .then(function (serverResponse) {
                  console.log(serverResponse.data);
                  
                  const posts = serverResponse.data;
                  console.log("audio " + posts);
                  const headerData = serverResponse;
                  const totalPages = headerData.headers['x-wp-totalpages'];
                  setPosts(posts);
                  setTotPages(Number(totalPages));
                  setShowLoading(false);
              })
              .catch(function (error) {
                  if (error.response) {
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                  } else if (error.request) {
                      console.log(error.request)
                  } else {
                      console.log('Error', error.message);
                  }
                  console.log(error.config);
                  setShowLoading(false);
              });
      }).catch(err => {//unable to load the local storage
          console.log("e: " + err.message);
      }
      );
      /***************FRANKENSTEIN'S MONSTER*************************/
    }
    // call loadPosts when component PostsContainer renders
    loadPosts();
  }, [page, catid]);

  function handleClickNextPage(newPage: number) {
    setPage(newPage);
  }
  function logOut(){
    console.log("logout");
    remove('cred');
    history.push('/home');
  }

  return (
    <IonPage>
      <LoginCheck/>
      <IonHeader translucent={true} >
        <IonToolbar>
            <IonButton size="small" slot="start" color="primary" onClick={() => history.push("/mindset/")} class="back"><IonIcon slot="start" icon={chevronBackOutline}/>Back</IonButton>
            <IonButton size="small" slot="end" color="primary" onClick={() => logOut()}  class="logout"><IonIcon slot="start" icon={logOutOutline}/>Log Out</IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent>
      <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Please wait...'}
          spinner={'bubbles'}
          duration={9000}
      />
         <IonText class="padded learntext">
        <h3><span>[</span> Practice <span>]</span></h3>
          <p>Through focus and practice, we strengthen pathways in our brain, Use these audio files regularly to practice your Explorer Mindset. An internet connection is needed to listen to these lessons, dynamically loaded from www.explorermindsetapp.com.
            </p>
      </IonText>
        <Audio
          listOfPosts={posts}
          totPages={totPages}
          handleClickNextPage={handleClickNextPage}
        />
      </IonContent>
      <FooterComponent/>
    </IonPage>
  );
}
